import React from "react";
import Paper from "@mui/material/Paper";
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import IconButton from "@mui/material/IconButton";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

import SidebarNavItem from "./SidebarNavItem";
import styles from "./FloatingSidebar.module.scss";

const FloatingSidebar = ({
  title,
  items,
  activeItemId,
  onItemSelect,
  collapsed,
  onToggleCollapse,
}) => {
  if (!items || items.length === 0) return null;

  const CollapseIcon = collapsed ? ChevronRightIcon : ChevronLeftIcon;
  const showTitle = Boolean(title) && !collapsed;
  const showHeader = showTitle || Boolean(onToggleCollapse);

  return (
    <Paper
      elevation={0}
      className={`${styles.sidebar} ${collapsed ? styles.sidebarCollapsed : ""}`}
    >
      {showHeader && (
        <div className={styles.sidebarHeader}>
          {showTitle && <h2 className={styles.sidebarTitle}>{title}</h2>}
          {onToggleCollapse && (
            <IconButton
              onClick={onToggleCollapse}
              className={styles.collapseIconButton}
              aria-label={collapsed ? "Expand sidebar" : "Collapse sidebar"}
            >
              <CollapseIcon />
            </IconButton>
          )}
        </div>
      )}

      <List className={styles.navList} disablePadding>
        {items.map((item, index) => {
          if (!item) return null;

          const isLastItem = index === items.length - 1;

          return (
            <React.Fragment key={item.id}>
              <SidebarNavItem
                item={item}
                isActive={item.id === activeItemId}
                isCollapsed={collapsed}
                onSelect={onItemSelect}
              />
              {!isLastItem && <Divider className={styles.navDivider} />}
            </React.Fragment>
          );
        })}
      </List>
    </Paper>
  );
};

export default FloatingSidebar;
